'use strict';
const angular = require('angular');

/*@ngInject*/
export function BulletinService($resource) {
  return $resource('/api/bulletins/:id', {
    id: '@_id'
  },{
    queryArchive: {
      method: 'GET',
      url: "/api/bulletins/archive",
      isArray: true
    },
    queryPublic: {
      method: 'GET',
      url: "/api/bulletins/public",
      isArray: true
    },
    getPublic: {
      method: 'GET',
      url: "/api/bulletins/public/:id"
    },
    queryProperty: {
      method: 'GET',
      url: "/api/bulletins/property",
      isArray: true
    },
    queryByRealtor: {
      method: 'GET',
      url: "/api/bulletins/realtor/:id",
      isArray: true
    },
    getNewest: {
      method: 'GET',
      url: "/api/bulletins/newest/:count",
      isArray: true
    },
    review: {
      method: 'PATCH',
      url: "/api/bulletins/:id/review"
    },
    patch: {
      method: 'PATCH'
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.BulletinService', [])
  .factory('BulletinService', BulletinService)
  .name;



// WEBPACK FOOTER //
// ./client/services/bulletin/bulletin.service.js